/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import produce from 'immer'
import { LANGUAGE_EN } from '@edulastic/constants/const/languages'
import { LanguageContext, notification } from '@edulastic/common'
import { withNamespaces } from 'react-i18next'
import { compose } from 'redux'
import { connect } from 'react-redux'

import {
  cloneDeep,
  keys as _keys,
  flattenDeep,
  isArray,
  find,
  last,
  isEmpty,
  difference,
  get,
} from 'lodash'
import loadable from '@loadable/component'
import Progress from '@edulastic/common/src/components/Progress'
import {
  getFormattedAttrId,
  reIndexResponses,
} from '@edulastic/common/src/helpers'
import { math, questionType } from '@edulastic/constants'
// import { ToolbarContainer } from "../../styled/ToolbarContainer";
// import { FroalaContainer } from "../../styled/FroalaContainer";
import { Subtitle } from '../../styled/Subtitle'
import Question from '../../components/Question'
import { getLanguageKeys } from '../../../common/utils/helpers'
import {
  getCurrentLanguage,
  getLanguageTabsSelector,
} from '../../../common/components/LanguageSelectorTab/duck'
import ClearContentConfirmationModal from '../../components/ConfirmClearStimulusModal'
import { getCurrentQuestionSelector } from '../../../author/sharedDucks/questions'
import { initializeLanguageObj } from '../../utils/question'
import { INITIAL_FIELD_VALUES_BY_QTYPE } from '../../constants/constantsForQuestions'

const INITIAL_FIELD_VALUES =
  INITIAL_FIELD_VALUES_BY_QTYPE[questionType.EXPRESSION_MULTIPART]

const FroalaEditor = loadable(() =>
  import(
    /* webpackChunkName: "froalaCommonChunk" */ '@edulastic/common/src/components/FroalaEditor'
  )
)

const { methods } = math

const initialMethod = {
  method: methods.EQUIV_SYMBOLIC,
  value: '',
  options: {},
  id: '',
}

const initialMathUnit = {
  method: methods.EQUIV_SYMBOLIC,
  options: {
    inverseResult: false,
  },
  value: '',
  id: '',
}

const initResponseId = {
  inputs: [],
  maths: [],
  dropDowns: [],
  mathUnits: [],
}

class Template extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showClearContentModal: false,
      prevItem: {},
    }
  }

  _reduceResponseIds = (tmpl, prevIds = {}) => {
    const newResponseId = cloneDeep(initResponseId)
    const { mathUnits = [], maths = [] } = prevIds
    if (!window.$) {
      return newResponseId
    }
    const temp = tmpl || ''
    const parsedHTML = $('<div />').html(temp)

    function findResponseIndexes(index) {
      const id = $(this).attr('id')
      const tagName = $(this)[0].tagName.toLowerCase()
      if (tagName === 'textinput') {
        newResponseId.inputs.push({ index, id })
      } else if (tagName === 'mathinput') {
        const { allowNumericOnly, allowedVariables, useTemplate, template } =
          maths.find((box) => box.id === id) || {}
        newResponseId.maths.push({
          index,
          id,
          allowNumericOnly,
          allowedVariables,
          useTemplate,
          template,
        })
      } else if (tagName === 'mathunit') {
        const prev = mathUnits.find((m) => m.id === id)
        if (prev) {
          newResponseId.mathUnits.push({ ...prev, index })
        } else {
          newResponseId.mathUnits.push({
            index,
            id,
            keypadMode: math.units[0].value,
          })
        }
      } else if (tagName === 'textdropdown') {
        newResponseId.dropDowns.push({ index, id })
      }
    }

    $(parsedHTML)
      .find('textinput, mathinput, textdropdown, mathunit')
      .each(findResponseIndexes)

    Object.keys(newResponseId).map((key) => {
      if (key !== 'scoringType') {
        if (isEmpty(newResponseId[key])) {
          delete newResponseId[key]
        }
      }
    })
    return newResponseId
  }

  _reduceValidation = (responseIds, validation) => {
    const _allIds = flattenDeep(
      _keys(responseIds).map((key) => responseIds[key])
    )
    const _validation = cloneDeep(validation)

    // remove correct answer (math input) by deleted response box id
    if (_validation.validResponse.value) {
      _validation.validResponse.value.map((val, index) => {
        if (!val[0].id) {
          _validation.validResponse.value.splice(index, 1)
        }
        const isExist = find(_allIds, (res) => res.id === val[0].id)
        if (!isExist) {
          _validation.validResponse.value.splice(index, 1)
        }
      })
    }

    // remove correct answer (math unit) by delted response box id
    if (_validation.validResponse.mathUnits) {
      _validation.validResponse.mathUnits.value.map((val, index) => {
        if (!val.id) {
          _validation.validResponse.mathUnits.value.splice(index, 1)
        }
        const isExist = find(_allIds, (res) => res.id === val.id)
        if (!isExist) {
          _validation.validResponse.mathUnits.value.splice(index, 1)
        }
      })
    }

    // remove correct answer (text input) by deleted response box id.
    if (_validation.validResponse.textinput) {
      _validation.validResponse.textinput.value.map((val, index) => {
        if (!val.id) {
          _validation.validResponse.textinput.value.splice(index, 1)
        }
        const isExist = find(_allIds, (res) => res.id === val.id)
        if (!isExist) {
          _validation.validResponse.textinput.value.splice(index, 1)
        }
      })
    }

    // remove correct answer (dropdown) by deleted response box id.
    if (_validation.validResponse.dropdown) {
      _validation.validResponse.dropdown.value.map((val, index) => {
        if (!val.id) {
          _validation.validResponse.dropdown.value.splice(index, 1)
        }
        const isExist = find(_allIds, (res) => res.id === val.id)
        if (!isExist) {
          _validation.validResponse.dropdown.value.splice(index, 1)
        }
      })
    }

    // add new correct answers with response id
    if (!_validation.validResponse) {
      _validation.validResponse = {
        score: 1,
        value: [],
        dropdown: { value: [] },
        textinput: { value: [] },
      }
    }
    _keys(responseIds).map((responsekey) => {
      responseIds[responsekey].map((res) => {
        if (responsekey === 'inputs') {
          if (!_validation.validResponse.textinput) {
            _validation.validResponse.textinput = { value: [] }
          }
          const isExist = find(
            _validation.validResponse.textinput.value,
            (valid) => valid.id === res.id
          )
          if (!isExist) {
            _validation.validResponse.textinput.value.push({
              value: '',
              id: res.id,
            })
          }
        }
        if (responsekey === 'maths') {
          if (!_validation.validResponse.value) {
            _validation.validResponse.value = []
          }
          const isExist = find(
            _validation.validResponse.value,
            (valid) => (valid[0] ? valid[0].id : '') === res.id
          )
          if (!isExist) {
            const newArray = [{ ...initialMethod, id: res.id }]
            _validation.validResponse.value.push(newArray)
          }
        }
        if (responsekey === 'dropDowns') {
          if (!_validation.validResponse.dropdown) {
            _validation.validResponse.dropdown = { value: [] }
          }
          const isExist = find(
            _validation.validResponse.dropdown.value,
            (valid) => valid.id === res.id
          )
          if (!isExist) {
            _validation.validResponse.dropdown.value.push({
              value: '',
              id: res.id,
            })
          }
        }
        if (responsekey === 'mathUnits') {
          if (!_validation.validResponse.mathUnits) {
            _validation.validResponse.mathUnits = { value: [] }
          }
          const isExist = find(
            _validation.validResponse.mathUnits.value,
            (valid) => valid.id === res.id
          )
          if (!isExist) {
            _validation.validResponse.mathUnits.value.push({
              ...initialMathUnit,
              id: res.id,
            })
          }
        }
      })
    })

    // reduce alternate answers
    const maxAltLen = _validation.altResponses
      ? _validation.altResponses.length
      : 0
    if (isArray(_validation.altResponses)) {
      // math input alternate responses
      if (_validation.validResponse.value) {
        _validation.altResponses.map((alt_res) => {
          if (!alt_res.value) {
            alt_res.value = []
          }
          if (_validation.validResponse.value.length > alt_res.value.length) {
            alt_res.value.push(last(_validation.validResponse.value))
          }
          alt_res.value.map((altAnswer, index) => {
            const isExist = find(
              _allIds,
              (res) => res.id === (altAnswer ? altAnswer[0] : '').id
            )
            if (!isExist) {
              alt_res.value.splice(index, 1)
            }
          })
        })
      }
      // textinput alternate responses
      if (_validation.validResponse.textinput) {
        _validation.altResponses.map((alt_res) => {
          if (!alt_res.textinput) {
            alt_res.textinput = {
              value: [],
            }
          }
          if (
            _validation.validResponse.textinput.value.length >
            alt_res.textinput.value.length
          ) {
            alt_res.textinput.value.push(
              last(_validation.validResponse.textinput.value)
            )
          }
          alt_res.textinput.value.map((altAnswer, index) => {
            const isExist = find(
              _allIds,
              (res) => res.id === (altAnswer || '').id
            )
            if (!isExist) {
              alt_res.textinput.value.splice(index, 1)
            }
          })
        })
      }
      // dropdown alternate responses
      if (_validation.validResponse.dropdown) {
        _validation.altResponses.map((alt_res) => {
          if (!alt_res.dropdown) {
            alt_res.dropdown = {
              value: [],
            }
          }
          if (
            _validation.validResponse.dropdown.value.length >
            alt_res.dropdown.value.length
          ) {
            alt_res.dropdown.value.push(
              last(_validation.validResponse.dropdown.value)
            )
          }
          alt_res.dropdown.value.map((altAnswer, index) => {
            const isExist = find(
              _allIds,
              (res) => res.id === (altAnswer || '').id
            )
            if (!isExist) {
              alt_res.dropdown.value.splice(index, 1)
            }
          })
        })
      }
      // Math Unit alternate responses
      if (_validation.validResponse.mathUnits) {
        _validation.altResponses.map((alt_res) => {
          if (!alt_res.mathUnits) {
            alt_res.mathUnits = {
              value: [],
            }
          }
          if (
            _validation.validResponse.mathUnits.value.length >
            alt_res.mathUnits.value.length
          ) {
            alt_res.mathUnits.value.push(
              last(_validation.validResponse.mathUnits.value)
            )
          }
          alt_res.mathUnits.value.map((altAnswer, index) => {
            const isExist = find(
              _allIds,
              (res) => res.id === (altAnswer || '').id
            )
            if (!isExist) {
              alt_res.mathUnits.value.splice(index, 1)
            }
          })
        })
      }
    } else if (_validation.validResponse) {
      const newAltValues = {
        score: 1,
        value: [],
        textinput: {
          value: [],
        },
        dropdown: {
          value: [],
        },
        mathUnits: {
          value: [],
        },
      }
      newAltValues.value = cloneDeep(
        get(_validation, 'validResponse.value', [])
      )
      newAltValues.value.map((answer) => {
        answer.value = ''
        return answer
      })
      newAltValues.textinput.value = cloneDeep(
        get(_validation, 'validResponse.textinput.value', [])
      )
      newAltValues.textinput.value.map((answer) => {
        answer.value = ''
        return answer
      })
      newAltValues.dropdown.value = cloneDeep(
        get(_validation, 'validResponse.dropdown.value', [])
      )
      newAltValues.dropdown.value.map((answer) => {
        answer.value = ''
        return answer
      })
      newAltValues.mathUnits.value = cloneDeep(
        get(_validation, 'validResponse.mathUnits.value', [])
      )
      newAltValues.mathUnits.value.map((answer) => {
        answer.value = ''
        return answer
      })
      _validation.altResponses = []
      for (let i = 0; i < maxAltLen; i++) {
        _validation.altResponses.push({
          score: 1,
          value: newAltValues,
        })
      }
    }

    // remove empty valid value if there is no response box(math, dropdown, or textinput)
    if (isEmpty(_validation.validResponse.value)) {
      delete _validation.validResponse.value
      _validation.altResponses = _validation.altResponses.map((alt_res) => {
        delete alt_res.value
        return alt_res
      })
    }
    if (
      _validation.validResponse.textinput &&
      isEmpty(_validation.validResponse.textinput.value)
    ) {
      delete _validation.validResponse.textinput
      _validation.altResponses = _validation.altResponses.map((alt_res) => {
        delete alt_res.textinput
        return alt_res
      })
    }
    if (
      _validation.validResponse.dropdown &&
      isEmpty(_validation.validResponse.dropdown.value)
    ) {
      delete _validation.validResponse.dropdown
      _validation.altResponses = _validation.altResponses.map((alt_res) => {
        delete alt_res.dropdown
        return alt_res
      })
    }
    if (
      _validation.validResponse.mathUnits &&
      isEmpty(_validation.validResponse.mathUnits.value)
    ) {
      delete _validation.validResponse.mathUnits
      _validation.altResponses = _validation.altResponses.map((alt_res) => {
        delete alt_res.mathUnits
        return alt_res
      })
    }

    return _validation
  }

  _reduceOptions = (responseIds = {}, options) => {
    const { dropDowns } = responseIds
    if (!dropDowns) {
      return
    }

    const newOptions = {}
    dropDowns.forEach((x) => {
      if (options && options[x.id]) {
        newOptions[x.id] = options[x.id]
      } else {
        newOptions[x.id] = []
      }
    })

    return newOptions
  }

  _reduceExtraOptions = (responseIds, extraOpts) => {
    const _allIds = flattenDeep(
      _keys(responseIds).map((key) => responseIds[key])
    ).map((res) => res.id)
    const extraOptionsIds = _keys(extraOpts)
    extraOptionsIds.forEach((id) => {
      if (!_allIds.includes(id)) {
        delete extraOpts[id]
      }
    })
    return extraOpts
  }

  // Helper function to extract IDs from HTML stimulus
  _extractIdsFromHtml = (htmlStr) => {
    if (!window.$ || !htmlStr) return []
    const parsedHTML = $('<div />').html(htmlStr)
    const ids = []
    $(parsedHTML)
      .find('textinput, mathinput, textdropdown, mathunit')
      .each(function () {
        const id = $(this).attr('id')
        if (id) ids.push(id)
      })
    return ids
  }

  // Validation guardrail to detect and correct state inconsistencies
  _validateAndCorrectStateConsistency = (stimulus, responseIds) => {
    try {
      const htmlIds = this._extractIdsFromHtml(stimulus)
      const responseIdsArray = Object.values(responseIds || {})
        .flat()
        .map((res) => res.id)
        .filter(Boolean)

      // Check for ID mismatches
      const extraInHtml = htmlIds.filter((id) => !responseIdsArray.includes(id))

      if (extraInHtml.length > 0) {
        // Auto-correct by regenerating responseIds from current HTML
        const correctedResponseIds = this._reduceResponseIds(
          stimulus,
          responseIds
        )

        return {
          isConsistent: false,
          correctedResponseIds,
          needsCorrection: true,
        }
      }

      return { isConsistent: true, needsCorrection: false }
    } catch (error) {
      return { isConsistent: true, needsCorrection: false } // Assume consistent if validation fails
    }
  }

  componentWillUnmount() {
    this.setState({
      showClearContentModal: undefined,
      prevItem: undefined,
    })
  }

  toggleShowClearContentModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      showClearContentModal: !prevState.showClearContentModal,
    }))
  }

  setTempContent = (prevItem = {}) => {
    this.setState((prevState) => ({
      ...prevState,
      prevItem: cloneDeep(prevItem),
    }))
  }

  handleModalResponse = (response) => {
    const { setQuestionData, item } = this.props
    const { prevItem } = this.state
    if (response === 'clear') {
      // Reset the stimulus and options
      setQuestionData(
        produce(item, (draft) => {
          draft.stimulus = ''
          draft.responseIds = {}
          delete draft.options
          draft.validation = {
            validResponse: {},
            altResponses: [],
          }
          getLanguageKeys(draft).forEach((lang) => {
            draft.languageFeatures[lang].stimulus = ''
            draft.languageFeatures[lang].responseIds = {}
            delete draft.languageFeatures[lang].options
            draft.languageFeatures[lang].validation = {
              validResponse: {},
              altResponses: [],
            }
          })
        }),
        LANGUAGE_EN
      )
      this.toggleShowClearContentModal()
      this.setTempContent()
    } else {
      if (!isEmpty(prevItem)) {
        setQuestionData(prevItem, LANGUAGE_EN)
      }
      this.toggleShowClearContentModal()
      this.setTempContent()
    }
  }

  _updateTemplate = (stimulus) => {
    try {
      const { item, setQuestionData, questionData } = this.props

      // Validation guardrail - check and correct initial state consistency
      const initialValidation = this._validateAndCorrectStateConsistency(
        stimulus,
        item.responseIds
      )
      if (initialValidation.needsCorrection) {
        // Update the item with corrected responseIds before proceeding
        setQuestionData(
          produce(item, (draft) => {
            draft.responseIds = initialValidation.correctedResponseIds
            draft.validation = this._reduceValidation(
              initialValidation.correctedResponseIds,
              draft.validation
            )
          })
        )
        return // Exit early after correction
      }

      const {
        item: { stimulus: prevStimulus = '' },
        currentLanguage = '',
        languageTabs = [],
      } = this.props

      /**
       * getLanguageKeys is a helper function to get the language keys of the current item
       */
      const languageKeys = getLanguageKeys(item)

      /**
       * when stimulus is empty we need to set the primary language as the first language
       * when stimulus is not empty we need to set the primary language as the English
       */
      const [primaryLanguage] = languageTabs

      /**
       * responseIds is the array of response box ids in the current stimulus
       */
      const responseIdsObj = this._reduceResponseIds(stimulus)
      const prevResponseIdObj = this._reduceResponseIds(prevStimulus)

      const responseIds = Object.values(responseIdsObj || {})
        .flatMap((response) => response.map(({ id }) => id))
        .filter(Boolean)

      const prevResponseIds = Object.values(prevResponseIdObj || {})
        .flatMap((response) => response.map(({ id }) => id))
        .filter(Boolean)

      /**
       * differenceOfResponseBoxCount is the difference of response box count between the previous stimulus and the current stimulus
       */
      const differenceOfResponseBoxCount =
        prevResponseIds?.length - responseIds?.length

      /**
       * isNewStimulusEmpty is a flag to check if the new stimulus is empty and the previous stimulus is not empty
       * and the difference of response box count is not 0
       */
      const isNewStimulusEmpty =
        differenceOfResponseBoxCount !== 0 &&
        (prevStimulus || '').trim().length &&
        !(stimulus || '').trim().length
      /**
       * when currentLanguage is not the primary language and the difference of response box count is not 0
       * we need to show the clear content modal
       */
      if (
        currentLanguage !== primaryLanguage &&
        differenceOfResponseBoxCount !== 0
      ) {
        /**
         * When stimulus is empty user is trying to remove all content + response boxes
         */
        if (isNewStimulusEmpty) {
          this.toggleShowClearContentModal(true)
          this.setTempContent(questionData)
          /** empty the stimulus for state update, require to update the component */
          setQuestionData(
            produce(questionData, (draft) => {
              draft.stimulus = ''
              languageKeys.forEach((lang) => {
                if (draft.languageFeatures[lang]) {
                  draft.languageFeatures[lang].stimulus = ''
                }
              })
            }),
            LANGUAGE_EN
          )
          return
        }
        /**
         * Here we return because response boxes are changed but stimulus is still present
         * It means user is trying to remove the response in other language tab (not primary),
         * No change FroalaEditor is reverting response box changes
         */
        notification({
          type: 'warn',
          messageKey: 'warnChangeInResponseBoxes',
        })
        return
      }

      // Remove response boxes
      if (differenceOfResponseBoxCount > 0) {
        const removedResponseIds = difference(prevResponseIds, responseIds)

        // Validation guardrail - check and correct state before removal
        const removalValidation = this._validateAndCorrectStateConsistency(
          stimulus,
          questionData.responseIds
        )
        if (removalValidation.needsCorrection) {
          // Apply correction and continue with removal
          setQuestionData(
            produce(questionData, (draft) => {
              draft.responseIds = removalValidation.correctedResponseIds
              draft.validation = this._reduceValidation(
                removalValidation.correctedResponseIds,
                draft.validation
              )
            })
          )
          return // Exit early after correction
        }

        setQuestionData(
          produce(questionData, (draft) => {
            if (primaryLanguage === LANGUAGE_EN) {
              draft.stimulus = stimulus

              draft.responseIds = this._reduceResponseIds(
                stimulus,
                draft.responseIds
              )

              draft.validation = this._reduceValidation(
                draft.responseIds,
                draft.validation
              )

              draft.options = this._reduceOptions(
                draft.responseIds,
                draft.options
              )

              if (draft.extraOpts) {
                draft.extraOpts = this._reduceExtraOptions(
                  draft.responseIds,
                  draft.extraOpts
                )
              }
              if (!draft.options) {
                delete draft.options
              }

              if (draft.validation.validResponse.value) {
                draft.validation.validResponse.value.map((res) => {
                  if (res && !res.length) {
                    res.push(initialMethod)
                  }
                  return res
                })
              }
            } else {
              initializeLanguageObj(
                draft,
                primaryLanguage,
                INITIAL_FIELD_VALUES
              )
              draft.languageFeatures[primaryLanguage].stimulus = stimulus

              draft.responseIds = this._reduceResponseIds(
                stimulus,
                draft.responseIds
              )

              draft.languageFeatures[
                primaryLanguage
              ].validation = this._reduceValidation(
                draft.responseIds,
                draft.languageFeatures[primaryLanguage].validation
              )

              draft.languageFeatures[
                primaryLanguage
              ].options = this._reduceOptions(
                draft.responseIds,
                draft.languageFeatures[primaryLanguage].options
              )

              if (draft?.languageFeatures?.[primaryLanguage]?.extraOpts) {
                draft.languageFeatures[
                  primaryLanguage
                ].extraOpts = this._reduceExtraOptions(
                  draft.responseIds,
                  draft.languageFeatures[primaryLanguage].extraOpts
                )
              }
              if (!draft.languageFeatures[primaryLanguage].options) {
                delete draft.languageFeatures[primaryLanguage].options
              }

              if (
                draft.languageFeatures?.[primaryLanguage]?.validation
                  ?.validResponse?.value
              ) {
                draft.languageFeatures[
                  primaryLanguage
                ].validation.validResponse.value.map((res) => {
                  if (res && !res.length) {
                    res.push(initialMethod)
                  }
                  return res
                })
              }
            }
            languageKeys
              .filter((language) => language !== primaryLanguage)
              .forEach((lang) => {
                initializeLanguageObj(draft, lang, INITIAL_FIELD_VALUES)
                const languageStimulus =
                  draft.languageFeatures[lang].stimulus || ''

                // Validation guardrail - check and correct multi-language state
                if (languageStimulus) {
                  this._validateAndCorrectStateConsistency(
                    languageStimulus,
                    draft.responseIds
                  )
                }

                const parsedHTML = $('<div />').html(languageStimulus)
                if (languageStimulus) {
                  removedResponseIds.forEach((responseId) => {
                    parsedHTML.find(`[id="${responseId}"]`).remove()
                  })
                }
                draft.languageFeatures[lang].stimulus = reIndexResponses(
                  parsedHTML.html() || ''
                )

                draft.languageFeatures[
                  lang
                ].validation = this._reduceValidation(
                  draft.responseIds,
                  draft.languageFeatures[lang].validation
                )

                draft.languageFeatures[lang].options = this._reduceOptions(
                  draft.responseIds,
                  draft.languageFeatures[lang].options
                )

                if (draft?.languageFeatures?.[lang]?.extraOpts) {
                  draft.languageFeatures[
                    lang
                  ].extraOpts = this._reduceExtraOptions(
                    draft.responseIds,
                    draft.languageFeatures[lang].extraOpts
                  )
                }
                if (!draft.languageFeatures[lang].options) {
                  delete draft.languageFeatures[lang].options
                }

                if (
                  draft.languageFeatures[lang].validation.validResponse.value
                ) {
                  draft.languageFeatures[
                    lang
                  ].validation.validResponse.value.map((res) => {
                    if (res && !res.length) {
                      res.push(initialMethod)
                    }
                    return res
                  })
                }
              })
          }),
          LANGUAGE_EN
        )
        return
      }

      /** 2. Adds response boxes */
      if (differenceOfResponseBoxCount < 0) {
        const newlyAddedResponseIds = {}
        for (const inputKey in responseIdsObj) {
          if (inputKey) {
            const _prevResponseIds = (prevResponseIdObj?.[inputKey] || [])
              .map((res) => res.id)
              .filter(Boolean)
            const newResponses = difference(
              (responseIdsObj?.[inputKey] || []).map(({ id }) => id),
              _prevResponseIds
            )

            if (newResponses.length) {
              newlyAddedResponseIds[inputKey] = newResponses
            }
          }
        }

        // Validation guardrail - check and correct state before addition
        const additionValidation = this._validateAndCorrectStateConsistency(
          stimulus,
          questionData.responseIds
        )
        if (additionValidation.needsCorrection) {
          // Apply correction and continue with addition
          setQuestionData(
            produce(questionData, (draft) => {
              draft.responseIds = additionValidation.correctedResponseIds
              draft.validation = this._reduceValidation(
                additionValidation.correctedResponseIds,
                draft.validation
              )
            })
          )
          return // Exit early after correction
        }

        setQuestionData(
          produce(questionData, (draft) => {
            if (primaryLanguage === LANGUAGE_EN) {
              draft.stimulus = stimulus

              draft.responseIds = this._reduceResponseIds(
                draft.stimulus,
                draft.responseIds
              )

              draft.validation = this._reduceValidation(
                draft.responseIds,
                draft.validation
              )

              draft.options = this._reduceOptions(
                draft.responseIds,
                draft.options
              )

              if (draft.extraOpts) {
                draft.extraOpts = this._reduceExtraOptions(
                  draft.responseIds,
                  draft.extraOpts
                )
              }
              if (!draft.options) {
                delete draft.options
              }

              if (draft.validation.validResponse.value) {
                draft.validation.validResponse.value.map((res) => {
                  if (res && !res.length) {
                    res.push(initialMethod)
                  }
                  return res
                })
              }
            } else {
              initializeLanguageObj(
                draft,
                primaryLanguage,
                INITIAL_FIELD_VALUES
              )

              draft.languageFeatures[primaryLanguage].stimulus = stimulus

              draft.responseIds = this._reduceResponseIds(
                stimulus,
                draft.responseIds
              )

              draft.languageFeatures[
                primaryLanguage
              ].validation = this._reduceValidation(
                draft.responseIds,
                draft.languageFeatures[primaryLanguage].validation
              )

              draft.languageFeatures[
                primaryLanguage
              ].options = this._reduceOptions(
                draft.responseIds,
                draft.languageFeatures[primaryLanguage].options
              )

              if (draft?.languageFeatures?.[primaryLanguage]?.extraOpts) {
                draft.languageFeatures[
                  primaryLanguage
                ].extraOpts = this._reduceExtraOptions(
                  draft.responseIds,
                  draft.languageFeatures[primaryLanguage].extraOpts
                )
              }
              if (!draft.languageFeatures[primaryLanguage].options) {
                delete draft.languageFeatures[primaryLanguage].options
              }

              if (
                draft.languageFeatures?.[primaryLanguage]?.validation
                  ?.validResponse?.value
              ) {
                draft.languageFeatures[
                  primaryLanguage
                ].validation.validResponse.value.map((res) => {
                  if (res && !res.length) {
                    res.push(initialMethod)
                  }
                  return res
                })
              }
            }
            languageKeys
              .filter((language) => language !== primaryLanguage)
              .forEach((lang) => {
                initializeLanguageObj(draft, lang, INITIAL_FIELD_VALUES)
                let languageStimulus =
                  draft.languageFeatures[lang].stimulus || ''
                for (const inputKey in newlyAddedResponseIds) {
                  if (inputKey) {
                    let currentIndex = responseIds.length
                    for (const responseId of newlyAddedResponseIds[inputKey]) {
                      if (inputKey === 'maths') {
                        languageStimulus += ` <mathinput id="${responseId}" contenteditable="false" key="${responseId}" responseindex=${currentIndex} ></mathinput> `
                      } else if (inputKey === 'mathUnits') {
                        languageStimulus += ` <mathunit id="${responseId}" contenteditable="false" key="${responseId}" responseindex=${currentIndex} ></mathunit> `
                      } else if (inputKey === 'inputs') {
                        languageStimulus += ` <textinput id="${responseId}" contenteditable="false" key="${responseId}" responseindex=${currentIndex} ></textinput> `
                      } else if (inputKey === 'dropDowns') {
                        languageStimulus += ` <textdropdown id="${responseId}" contenteditable="false" key="${responseId}" responseindex=${currentIndex} ></textdropdown> `
                      }
                      currentIndex++
                    }
                  }
                }

                draft.languageFeatures[lang].stimulus = languageStimulus

                draft.languageFeatures[
                  lang
                ].validation = this._reduceValidation(
                  draft.responseIds,
                  draft.languageFeatures[lang].validation
                )

                draft.languageFeatures[lang].options = this._reduceOptions(
                  draft.responseIds,
                  draft.languageFeatures[lang].options
                )

                if (draft?.languageFeatures?.[lang]?.extraOpts) {
                  draft.languageFeatures[
                    lang
                  ].extraOpts = this._reduceExtraOptions(
                    draft.responseIds,
                    draft.languageFeatures[lang].extraOpts
                  )
                }
                if (!draft.languageFeatures[lang].options) {
                  delete draft.languageFeatures[lang].options
                }

                if (
                  draft.languageFeatures[lang].validation.validResponse.value
                ) {
                  draft.languageFeatures[
                    lang
                  ].validation.validResponse.value.map((res) => {
                    if (res && !res.length) {
                      res.push(initialMethod)
                    }
                    return res
                  })
                }
              })
          }),
          LANGUAGE_EN
        )
        return
      }

      setQuestionData(
        produce(item, (draft) => {
          draft.stimulus = stimulus

          // Validation guardrail - check and correct state before update
          const beforeValidation = this._validateAndCorrectStateConsistency(
            stimulus,
            item.responseIds
          )

          if (beforeValidation.needsCorrection) {
            // Use corrected responseIds
            draft.responseIds = beforeValidation.correctedResponseIds
            draft.validation = this._reduceValidation(
              beforeValidation.correctedResponseIds,
              draft.validation
            )
          } else {
            // Normal flow
            draft.responseIds = this._reduceResponseIds(
              draft.stimulus, // current stimulus
              draft.responseIds // previous response ids
            )

            draft.validation = this._reduceValidation(
              draft.responseIds, // current response ids
              draft.validation // previous validation
            )
          }

          // Validation guardrail - verify state after update
          this._validateAndCorrectStateConsistency(
            draft.stimulus,
            draft.responseIds
          )

          // reduce options from current responseIds and previous options
          draft.options = this._reduceOptions(draft.responseIds, draft.options)

          if (draft.extraOpts) {
            draft.extraOpts = this._reduceExtraOptions(
              draft.responseIds, // current response ids
              draft.extraOpts // previous extra options
            )
          }
          if (!draft.options) {
            delete draft.options // remove options if empty
          }

          if (draft.validation.validResponse.value) {
            // Only for math input, if valid response is empty, add initial method
            // value = [[initialMethod]]
            draft.validation.validResponse.value.map((res) => {
              if (res && !res.length) {
                res.push(initialMethod)
              }
              return res
            })
          }
        })
      )
    } catch (error) {
      console.log('Error in updating template', error)
    }
  }

  render() {
    const {
      t,
      item,
      fillSections,
      cleanSections,
      languageTabs = [],
      currentLanguage,
    } = this.props
    const { showClearContentModal } = this.state

    return (
      <Question
        section="main"
        label={t('component.math.composequestion')}
        fillSections={fillSections}
        cleanSections={cleanSections}
      >
        <Subtitle
          id={getFormattedAttrId(
            `${item?.title}-${t('component.math.composequestion')}`
          )}
          data-cy="template"
        >
          {t('component.math.composequestion')}
        </Subtitle>
        <LanguageContext.Provider value={{ currentLanguage, languageTabs }}>
          <FroalaEditor
            fallback={<Progress />}
            data-cy="templateBox"
            onChange={this._updateTemplate}
            value={item.stimulus}
            additionalToolbarOptions={['responseBoxes']}
            toolbarId="template-markup-area"
            border="border"
          />
        </LanguageContext.Provider>

        <ClearContentConfirmationModal
          handleModalResponse={this.handleModalResponse}
          showClearContentModal={showClearContentModal}
          primaryLanguage={languageTabs[0]}
        />
      </Question>
    )
  }
}

Template.propTypes = {
  t: PropTypes.func.isRequired,
  setQuestionData: PropTypes.func.isRequired,
  item: PropTypes.object,
  fillSections: PropTypes.func,
  cleanSections: PropTypes.func,
}

Template.defaultProps = {
  item: {},
  fillSections: () => {},
  cleanSections: () => {},
}

const enhance = compose(
  withNamespaces('assessment'),
  connect((state) => ({
    currentLanguage: getCurrentLanguage(state),
    languageTabs: getLanguageTabsSelector(state),
    questionData: getCurrentQuestionSelector(state),
  }))
)

export default enhance(Template)
